var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import classNames from "classnames";
import React from "react";
import { Card, CardMedia } from "@riseart/card";
import { Link } from "@riseart/common";
import { isTouchDevice } from "@riseart/fe-utils";
import { activitySimpleCls, activitySimpleTouchCls, activitySimpleLabelCls, activitySimpleActionCls } from "./Simple.less";
function ActivitySimpleCard(_ref) {
  var _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, _ref$actionControls = _ref.actionControls, actionControls = _ref$actionControls === void 0 ? null : _ref$actionControls, _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, linkProps = _ref.linkProps, picture = _ref.picture;
  if (!picture && !title) {
    return null;
  }
  var titleSection = title ? /* @__PURE__ */ React.createElement("div", {
    className: activitySimpleLabelCls
  }, title) : null;
  return /* @__PURE__ */ React.createElement(Card, {
    className: classNames(activitySimpleCls, actionControls && isTouchDevice() && activitySimpleTouchCls, className),
    showBorder: false
  }, /* @__PURE__ */ React.createElement(CardMedia, null, linkProps ? /* @__PURE__ */ React.createElement(Link, linkProps, picture, titleSection) : /* @__PURE__ */ React.createElement(React.Fragment, null, picture, titleSection), actionControls ? /* @__PURE__ */ React.createElement("div", {
    className: activitySimpleActionCls
  }, actionControls) : null));
}
__name(ActivitySimpleCard, "ActivitySimpleCard");
export {
  ActivitySimpleCard
};
